import { useMutation } from '@tanstack/react-query'

import type { TermsApi } from '@b-stock/account-api-client'
import { useAccessToken } from '@b-stock/fe-core/bstock-next/components'
import { getTermsClient } from '@b-stock/fe-core/bstock-next/queries'
import { buildAxiosRequestConfig } from '@b-stock/fe-core/bstock-react'

import useAccountId from '@/buyer-portal/helpers/useAccountId'

export const useAcceptTermsRestrictions = (
  policy: string,
  onSuccess?: () => void,
  onError?: (error: unknown) => void
) => {
  const accessToken = useAccessToken()
  const accountId = useAccountId()

  const { isPending, mutate } = useMutation({
    mutationFn: async () => {
      if (!accountId) {
        throw new Error('No accountId available.')
      }

      const termsClient: TermsApi = getTermsClient()
      return termsClient.acceptPolicy(
        { id: accountId, policy },
        buildAxiosRequestConfig({ accessToken })
      )
    },
    onSuccess,
    onError,
  })

  return {
    isPending,
    acceptPolicy: mutate,
  }
}
